export enum DashboardType {
  Countries = 'country',
  PolicyInstruments = 'policy',
  TargetGroups = 'target'
}
